import { Box, Center, Flex, Icon } from "@chakra-ui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import { noop } from "../../../../utils";
import { IAppModalProps } from "./types.ts";

/**
 * Application modal wrapper (mobile).
 * It renders content of every modal window in the app.
 *
 * To show modal use useAppModal hook.
 *
 * @see useAppModal
 */
export function MobileModalView({ content, header, onClose, block, isBlocked }: IAppModalProps) {
  return (
    <Flex bg="white" borderTopRadius="xl" px={4} paddingBottom={9} position="relative" flexDir="column">
      <Icon
        onClick={onClose}
        as={XMarkIcon}
        boxSize={6}
        top={5}
        right={5}
        position="absolute"
        cursor="pointer"
        color="brand.500"
      />
      <Box py={5}>
        { header && (
          <Center h="24px" color="brand.500">
            {header}
          </Center>
        ) }
      </Box>

      {content?.(onClose ?? noop, block ?? noop, isBlocked ?? false)}
    </Flex>
  );
}
